export var ViewResizeMode;
(function (ViewResizeMode) {
    /**
     * 在保持纵横比的同时等比缩放显示所有内容
     */
    ViewResizeMode[ViewResizeMode["Uniform"] = 0] = "Uniform";
    /**
     * 在保持纵横比的同时保证横向显示尽可能多的空间，
     */
    ViewResizeMode[ViewResizeMode["HorizontalUniform"] = 1] = "HorizontalUniform";
})(ViewResizeMode || (ViewResizeMode = {}));
